document.addEventListener('DOMContentLoaded', function () {
    const menu = document.querySelector('.iniciatives-page-menu');
    const footer = document.querySelector('footer'); // Seleciona o footer
    const initialTop = menu.offsetTop; // Posição inicial do menu
    const initialLeft = menu.offsetLeft; // Posição inicial à esquerda
    const menuHeight = menu.offsetHeight; // Altura do menu

    window.addEventListener('scroll', function () {
        const scrollTop = window.scrollY; // Posição atual do scroll vertical
        const footerOffset = footer.offsetTop; // Distância do footer em relação ao topo da página
        const viewportHeight = window.innerHeight; // Altura da janela visível

        // Calcula o ponto exato onde o menu colidirá com o footer
        const menuBottom = scrollTop + menuHeight;

        if (menuBottom >= footerOffset) {
            // Se o menu colide com o footer, volta para "absolute"
            menu.classList.remove('fixed');
            menu.classList.add('absolute');
            menu.style.top = `${footerOffset - menuHeight}px`; // Para antes do footer
            menu.style.left = `${initialLeft}px`; // Mantém o alinhamento horizontal
        } else if (scrollTop >= initialTop) {
            // Quando o usuário rola além do ponto inicial, fixa o menu
            menu.classList.remove('absolute');
            menu.classList.add('fixed');
            menu.style.top = `0`; // Fixa no topo da viewport
            menu.style.left = `${initialLeft}px`; // Mantém o alinhamento horizontal
        } else {
            // Volta ao posicionamento absoluto se estiver acima do ponto inicial
            menu.classList.remove('fixed', 'absolute');
            menu.style.top = `${initialTop}px`; // Retorna à posição inicial
            menu.style.left = `${initialLeft}px`; // Mantém o alinhamento horizontal
        }
    });
	// Configuração do menu mobile com submenu recolhido
    const menuMobile = document.querySelector('.iniciatives-page-menu-mobile');

    if (menuMobile) {
        const initialTop = menuMobile.offsetTop;
        const menuHeight = menuMobile.offsetHeight;
        const submenuTrigger = menuMobile.querySelector('.menu-item-has-children'); // <li> que contém o submenu
        const submenu = submenuTrigger ? submenuTrigger.querySelector('ul') : null; // <ul> dentro da <li>

        // Garante que o submenu inicie recolhido
        if (submenu) {
            submenu.style.display = 'none';
        }

        // Adiciona evento de clique para abrir e fechar o submenu
        submenuTrigger.addEventListener('click', function (event) {
            event.preventDefault(); // Evita que links disparem ação de navegação
            if (submenu.style.display === 'none') {
                submenu.style.display = 'block'; // Expande o submenu
            } else {
                submenu.style.display = 'none'; // Recolhe o submenu
            }
        });

        window.addEventListener('scroll', function () {
            const scrollTop = window.scrollY;
            const viewportHeight = window.innerHeight;
            const footerOffset = footer.offsetTop;
            const menuBottom = scrollTop + viewportHeight;

            if (menuBottom >= footerOffset) {
                menuMobile.classList.remove('fixed');
                menuMobile.style.position = 'absolute';
                menuMobile.style.top = `${footerOffset - menuHeight}px`;
            } else if (scrollTop + viewportHeight >= initialTop) {
                menuMobile.classList.add('fixed');
                menuMobile.style.position = 'fixed';
                menuMobile.style.bottom = '0';
                menuMobile.style.top = 'auto';
            } else {
                menuMobile.classList.remove('fixed');
                menuMobile.style.position = 'absolute';
                menuMobile.style.top = '88rem'; // Posição inicial definida no CSS
            }
        });
    }
});


